/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import Solicitar from "@/components/Solicitar";
import Solicitudes from "@/components/Solicitudes";
import Incorporacion from "@/components/Incorporacion";
import Unauthorized from "@/components/Unauthorized";
import auth from "../app/auth";
import LogoutSuccess from "@/components/LogoutSuccess";
import ErrorComponent from "@/components/Error";
import RedirectComponent from "@/components/Redirect";
import Success from "@/components/Success";
import Ingreso from "@/components/Ingreso";
import { is_auth } from "./../middleware/is_auth";
import { solicitud_success } from "./../middleware/solicitud_success";
import { solicitud_incorporacion } from "./../middleware/solicitud_incorporacion";
import { user_registro } from "./../middleware/user_registro";

Vue.use(Router);

function multiple(guards) {
  return (to, from, next) => {
    const stack = [].concat(guards);
    function another() {
      const guard = stack.pop();
      guard ? guard(to, from, another) : next();
    }
    another();
  };
}

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    // {
    //   path: '/solicitar',
    //   name: 'solicitar',
    //   beforeEnter: user_registro,
    //     component: Solicitar
    // },
    // {
    //   path: '/solicitudes',
    //   name: 'Solicitudes',
    //   beforeEnter: is_auth,
    //   component: Solicitudes
    // },
    {
      path: "/ingreso",
      name: "Ingreso",
      beforeEnter: multiple([is_auth, solicitud_incorporacion]),
      component: Ingreso,
    },
    {
      path: "/incorporacion",
      name: "Incorporacion",
      beforeEnter: multiple([is_auth, solicitud_incorporacion]),
      component: Incorporacion,
    },
    {
      path: "/redirect",
      beforeEnter: is_auth,
      name: "Redirect",
      component: RedirectComponent,
    },
    {
      path: "/unauthorized",
      name: "Unauthorized",
      component: Unauthorized,
    },
    {
      path: "/Success",
      name: "Success",
      beforeEnter: multiple([is_auth, solicitud_success]),
      component: Success,
    },
    {
      path: "/",
      component: LogoutSuccess,
      async beforeEnter(to, from, next) {
        // await auth.logoutClaveUnica();
        next();
      },
    },
    {
      path: "/login",
      beforeEnter(to, from, next) {
        auth.auth.getSession();
      },
    },
    {
      path: "/oauth2",
      beforeEnter(to, from, next) {
        var currUrl = window.location.href;

        auth.auth.parseCognitoWebResponse(currUrl);
        //next();
      },
    },
    {
      path: "/logout",
      component: LogoutSuccess,
      beforeEnter(to, from, next) {
        // auth.logoutClaveUnica();
        next();
      },
    },
    {
      path: "/auth/login",
      component: LogoutSuccess,
      beforeEnter(to, from, next) {
        next();
      },
    },
    {
      path: "/error",
      name: "Error",
      component: ErrorComponent,
    },
    {
      path: "*/*",
      beforeEnter(to, from, next) {
        next({ path: "error", query: { message: "pagina no encontrada" } });
      },
    },
  ],
});
